module.exports = __webpack_public_path__ + "static/media/hualian_pic1.63a5a6be.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic1.jpg
 ** module id = 444
 ** module chunks = 0
 **/